import { I18n } from "aws-amplify";
import PropTypes from "prop-types";
import React from "react";

Infos.propTypes = {
    informations: PropTypes.object.isRequired
}

function Infos(props) {
    return props.informations.laboratoires && (
        <div className="flex flex-column w-full">
            <h5 className="flex pt-2">{I18n.get("laboratoires")}&nbsp;:</h5>
            {props.informations.laboratoires.map((laboratoire) => (
                <div key={laboratoire.nom} className="flex flex-column w-full pt-2 pb-4">
                    <div className="text-xl justify-content-center">
                        <i className="pi pi-map-marker" style={{ fontSize: "1rem" }}></i> {laboratoire.nom}
                    </div>
                    <div>
                        {I18n.get("address")} : {laboratoire.adresse}
                    </div>
                    <div>
                        {I18n.get("tel")} : {laboratoire.telephone}
                    </div>
                    {laboratoire.gsm && <div>
                        {I18n.get("gsm")} : {laboratoire.gsm}
                    </div>}
                    {laboratoire.fax && <div >
                        {I18n.get("fax")} : {laboratoire.fax}
                    </div>}
                    {laboratoire.email && <div>
                        {I18n.get("email")} : {laboratoire.email}
                    </div>}
                    {laboratoire.site && <div>
                        {I18n.get("site")} : <a href={laboratoire.site} target="_blank" rel="noopener noreferrer">{laboratoire.site}</a>
                    </div>}
                    {laboratoire.personne && <div>
                        {I18n.get("directeurLabo")} : {laboratoire.personne}
                    </div>}
                    {laboratoire.secretaire && <div>
                        {I18n.get("secretaire")} : {laboratoire.secretaire}
                    </div>}
                </div>
            ))}
        </div>
    );
}

export default Infos;